/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["tr[_ngcontent-%COMP%]:nth-child(odd){background-color:#f3f3f3}#no-questions-message[_ngcontent-%COMP%]{text-align:center}"];
export { styles as styles };
//# sourceMappingURL=faq-list.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/faq/faq-list/faq-list.component.scss.shim.ngstyle.js
// module id = 1638
// module chunks = 26 27 28